import { jsonp } from '@ifeng-fe/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable */
let apiBaseUrl = apiUrl;

/* eslint-enable */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

export const formatVideoPlayUrl = vurl => {
    let subStr = '';

    try {
        subStr = vurl.substring(0, vurl.lastIndexOf('.'));
    } catch (error) {
        subStr = null;
    }

    return `${subStr}/index.m3u8`;
};

export const getGongyiVideoData = async keys => {
    const res = await jsonp(`${apiBaseUrl}/getVideoData/${keys}/getGongyiVideoData1`, {
        jsonpCallback: 'getGongyiVideoData1',
        cache: false,
    });

    return res.data;
};

// 获取社招岗位列表
export const getRecruitList = async params => {
    const res = await jsonp(`${apiBaseUrl}/career/recruit/list/${params}/getRecruitTableList`, {
        jsonpCallback: 'getRecruitTableList',
        cache: 120,
    });

    return res;
};

// 获取岗位列表(Moka)
export const getRecruitListFromMoka = async params => {
    const res = await jsonp(`${apiBaseUrl}/career/recruitFromMoka/list/${params}/getRecruitTableList`, {
        jsonpCallback: 'getRecruitTableList',
        cache: 120,
    });

    return res;
};

// 获取岗位地址列表(Moka)
export const getRecruitLocationFromMoka = async mode => {
    const res = await jsonp(`${apiBaseUrl}/career/recruitFromMoka/localtionList/${mode}/getRecruitLocation`, {
        jsonpCallback: 'getRecruitLocation',
        cache: 120,
    });

    return res;
};

// 获取岗位地址列表(Moka)
export const getRecruitZhiNengFromMoka = async mode => {
    const res = await jsonp(`${apiBaseUrl}/career/recruitFromMoka/zhinengList/${mode}/getRecruitZhiNeng`, {
        jsonpCallback: 'getRecruitZhiNeng',
        cache: 120,
    });

    return res;
};

// 获取社招岗位详情
export const getRecruitDetail = async params => {
    const res = await jsonp(`${apiBaseUrl}/career/recruit/detail/${params}/getRecruitDetail`, {
        jsonpCallback: 'getRecruitDetail',
        cache: 120,
    });

    console.log('recruitdetail==', res);

    return res;
};

// 获取社招岗位详情
export const getRecruitDetailFromMoka = async params => {
    const res = await jsonp(`${apiBaseUrl}/career/recruitFromMoka/detail/${params}/getRecruitDetail`, {
        jsonpCallback: 'getRecruitDetail',
        cache: 120,
    });

    return res;
};

// 获取应届生岗位列表
export const getGraduateList = async () => {
    const res = await jsonp(`${apiBaseUrl}/career/graduate/getGraduateTableList`, {
        jsonpCallback: 'getGraduateTableList',
        cache: 120,
    });

    return res;
};

// 获取实习生岗位列表
export const getCampusList = async (name, type, add) => {
    // eslint-disable-next-line newline-after-var

    const res = await jsonp(`${apiBaseUrl}/career/campus/getCampusTableList`, {
        jsonpCallback: 'getCampusTableList',
        cache: 120,
    });

    return res;
};

// 获取 视频信息
export const getVideoDetail = async guid => {
    const res = await jsonp(`${apiBaseUrl}/career/video/${guid}/getVideoDetail`, {
        jsonpCallback: 'getVideoDetail',
        cache: 120,
    });

    console.log('ress===', res);

    return res;
};

// 获取 多条视频信息
export const getVideoList = async guids => {
    const res = await jsonp(`${apiBaseUrl}/career/videoList/${guids}/videoPlayList`, {
        jsonpCallback: 'videoPlayList',
        cache: 120,
    });

    return res;
};

// 提交实习生简历
export const submitCampusResume = async paramsObj => {
    const { jobid, name, gender, education, email, phone, school, year, month, day, sid, rid } = paramsObj;
    const date = new Date(year, month, day);
    const timeStamp = Math.round(date.getTime() / 1000);

    try {
        return await jsonp('https://api.cmpp.v.ifeng.com/resume/submitResume', {
            data: {
                applyName: name,
                applySex: gender,
                applyXueli: education,
                applySchool: school,
                applyEmail: email,
                applyMobile: phone,
                applyBtime: timeStamp,
                jobId: jobid,
                sid,
                rid,
                rt: 'jsonp',
                applyJob: '',
            },
            type: 'get',
            jsonpCallback: 'applyCampus',
            cache: true,
        });
    } catch (e) {
        console.log('submitcampus===', e);
        console.error(e);
    }
};

// 提交社招简历
export const submitRecruitResume = async paramsObj => {
    const { jobid, name, gender, education, email, phone, school, year, month, day, attachId } = paramsObj;
    const today = new Date();

    const y = today.getFullYear();
    const m = today.getMonth() + 1;
    const d = today.getDate();
    const updatetime = `${y}-${m}-${d}`;
    const birth = `${year}-${month}-${day}`;
    const datainfo = {
        jobid,
        name,
        gender,
        birthday: birth,
        education,
        email,
        phone,
        attfile: attachId,
        source: '官网',
        updatetime,
        college: school,
        addr: '',
        status: '',
        headpic: '',
    };

    const params = encodeURIComponent(JSON.stringify(datainfo));
    const res = await jsonp(`${apiBaseUrl}/career/recruit/apply/${params}/applyRecruit`, {
        jsonpCallback: 'applyRecruit',
        cache: 120,
    });

    console.log('submitRecruitResume==', res);

    return res;
};
